const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJumpSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-284.3)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.8363843
    },
    d: "m 32.09594,305.40874 c 0.06784,-0.528 0.118711,-1.06425 0.118711,-1.60874 0,-0.54449 -0.05087,-1.08074 -0.118711,-1.60875 l 3.586728,-2.73074 c 0.322211,-0.24749 0.415484,-0.69301 0.203503,-1.056 l -3.391704,-5.71725 c -0.211982,-0.35475 -0.652904,-0.50325 -1.03447,-0.35475 l -4.222672,1.65825 c -0.873365,-0.65176 -1.831521,-1.2045 -2.865989,-1.62526 l -0.635944,-4.3725 c -0.07631,-0.38774 -0.423965,-0.693 -0.847928,-0.693 h -6.783407 c -0.423963,0 -0.771613,0.30526 -0.839447,0.693 l -0.635945,4.3725 c -1.03447,0.42076 -1.992625,0.96525 -2.86599,1.62526 l -4.2226711,-1.65825 c -0.381567,-0.14026 -0.8224885,0 -1.0344701,0.35475 l -3.3917033,5.71725 c -0.2119827,0.35474 -0.1187103,0.80024 0.2035023,1.056 l 3.5782473,2.73074 c -0.067836,0.52801 -0.1187103,1.06426 -0.1187103,1.60875 0,0.54449 0.050869,1.08074 0.1187103,1.60874 l -3.5782473,2.73077 c -0.3222126,0.24749 -0.415485,0.69299 -0.2035023,1.05599 l 3.3917033,5.71724 c 0.2119816,0.35475 0.6529031,0.50326 1.0344701,0.35475 l 4.2226711,-1.65823 c 0.873365,0.65173 1.83152,1.2045 2.86599,1.62524 l 0.635945,4.3725 c 0.06783,0.38775 0.415484,0.693 0.839447,0.693 h 6.783407 c 0.423963,0 0.771612,-0.30525 0.839448,-0.693 l 0.635944,-4.3725 c 1.034469,-0.42074 1.992624,-0.96525 2.865989,-1.62524 l 4.222672,1.65823 c 0.381567,0.14025 0.822488,0 1.034471,-0.35475 l 3.391703,-5.71724 c 0.211981,-0.35475 0.118709,-0.80024 -0.203502,-1.05599 z M 19.49576,309.575 c -3.281473,0 -5.935481,-2.58225 -5.935481,-5.775 0,-3.19275 2.654008,-5.775 5.935481,-5.775 3.281475,0 5.935482,2.58225 5.935482,5.775 0,3.19275 -2.654007,5.775 -5.935482,5.775 z",
    id: "path3701"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 2.41709733,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 37,34 V 30.169671 L 47.137148,37.83034 37,45.490995 V 41.660666 H 26.862855 V 34 Z",
    id: "path3690"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpSettings);
export default __webpack_public_path__ + "static/media/jump-settings.d72a34397510b47a9593b5ada35eb6d4.svg";
export { ForwardRef as ReactComponent };